import React from 'react'
import _ from "lodash"

import {Skeleton} from "@material-ui/lab";
import IconButton from "@material-ui/core/IconButton";
import InputFormElement, {
  CurrencyNumberFormat,
} from "../../../../../../formElement/InputFormElement";
import Link from "../../../../../../../../../../../components/Link";
import {PercentageNumberFormat} from "../../../../../../formElement/InputFormElement/InputFormElement";
import {makeStyles} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import {
  InstrumentNameCell, PriceColumn,
  SRRIColumn
} from "../../../../../../../../../../Modelportfolios/components/InstrumentsList/table-data";
import {acceptanceCriteriasExists, getInstrName} from "../../../../../../../../../../Modelportfolios/utils";
import {InfoIcon} from "../../../../../../../../../../../images";
import {FilteringAcceptanceCriteriasModal} from "../../../../../../../../../../Modelportfolios/components";
import {instrCustodianData} from '../../../../../../../../../../Trades/utils';
import {useRiskScoreConfirmationModalContext} from "../../InvestmentRecommendationStep";
import {withEuroOrDash, withPercentOrDash} from "../../../../../../../../../../../utils/utils";
import WarningTooltip from "../../../../../../../../../../../components/WarningTooltip";
import {SustainabilityCell} from "../../../../../../../../../../../utils/commonTableColumns";
import BcaIconButton, {BcaDeleteIconButton} from "../../../../../../../../../../../components/Buttons/BcaIconButton/BcaIconButton";
import {WARNING_COLOR} from "../../../../../../../../../../../themes/themeConfigurator";
import SavingPlanSettings from "../../../../../ProductSelectionStepsV2/components/SavingPlanSetting";
import SingleBuyBookingDate from "../../../../../ProductSelectionStepsV2/components/SingleBuyBookingDate";
import {
  LimitOrderColumn,
  NumberOfSharesColumn,
  PortfolioNameCell
} from "../../../../../../../../../../Trades/components/TradeStep/components/PortfolioTrade/table-data";
import PrimaryButton from "../../../../../../../../../../../components/Buttons/PrimaryButton";
import SharesSettings from "../../../../../ProductSelectionStepsV2/components/SharesSettings";

const useCellStyles = makeStyles(() => ({
  inputRoot: {
    margin: 0,
    height: 30,
    fontSize: 14
  },
  actionLink: {
    margin: '0 0.6rem',
    '&:first-child': {
      marginLeft: 0
    },
    '&:last-child': {
      marginRight: 0
    }
  },
  tooltip: {
    position: 'relative',
    top: -10
  },
  disabledLabel: {
    border: '1px solid #80858C',
    color: '#80858C',
    borderRadius: 2,
    fontFamily: 'Roboto-Regular',
    fontSize: 10,
    textTransform: 'uppercase',
    padding: '4px 6px'
  },
  reasonBtn: {
    color: WARNING_COLOR,
    position: 'absolute',
    top: -6
  },
  rotateIcon: {
    width: 30,
    height: 30,
  }
}));

const StateCol = {
  header: [() => ''],
  body: [({item, options}) => {
    const classes = useCellStyles();
    const [acceptanceVisible, setAcceptanceVisibility] = React.useState(false);

    if(options.readOnly){
      if(_.get(item, 'tableProps.summaryLine')){
        const expandClick = () => options.expandSummaryLineChange(item, !item.showAssets);

        return (
          <IconButton className={classes.rotateIcon} disableRipple aria-label="back" onClick={expandClick}>
            <i className={item.showAssets ? "far fa-angle-up" : "far fa-angle-down"} aria-hidden="true" />
          </IconButton>
        )
      }

      return null;
    }

    // We do not validate instruments for open only, so we can skip disabledByFilter validation
    if (options.isOpenOnly) {

      if (item.infoText) {
        return (<WarningTooltip title={item.infoText} icon={<i><InfoIcon color="#80858c" /></i>}/>)
      }

      return null
    }

    const handleShowAcceptanceCriteriasClick = () => {
      setAcceptanceVisibility(true)
    };

    const handleCloseAcceptanceCriterias = () => {
      setAcceptanceVisibility(false)
    };

    if (!item.disabledByFilter) return (
      <>
        {!item.dirty && !options.isNewDesign && <span className={classes.disabledLabel}>NEU</span>}
      </>
    );

    if (acceptanceCriteriasExists(item)) return (
      <>
        <InfoIcon color="#80858c" onClick={handleShowAcceptanceCriteriasClick}/>
        <FilteringAcceptanceCriteriasModal
          open={acceptanceVisible}
          onClose={handleCloseAcceptanceCriterias}
          instrumentName={getInstrName(item) || item.isin}
          criterias={item.disabledByAcceptanceCriterias} />
      </>
    );
  }]
}

// NOTE: Component should return null if nothing to render
const NameCol = {
  header: [({item, options}) => InstrumentNameCell.header.content(item, options) || null],
  body: [({item, options}) => InstrumentNameCell.body.content(item, options) || null],
  footer: [({options}) => {
    return <b>
      {options.error && (<span style={{color: 'red'}}>{options.error}</span>)}
    </b>
  }],
  colSpan: {footer: 6},
};

export const NameColNew = {
  header: [({item, options}) => InstrumentNameCell.header.content(item, options) || null],
  body: [({item, options}) => {
    if(item.isInvestmentStrategy || item.is_modelportfolio){
      return <PortfolioNameCell portfolio={{...item, mp_number: item.isInvestmentStrategy ? item.portfolio_id : item.agency_portfolio_id}} />
    }

    return InstrumentNameCell.body.content(item, options) || null
  }],
  footer: [({options}) => {
    return !!options.onAddAssetClick && (
      <PrimaryButton
        text={'Investment hinzufügen'}
        icon={<i className={'fal fa-plus'} />}
        onButtonClick={options.onAddAssetClick}
      />
    )
  }],
  colSpan: {footer: 5},
  cellClassName: 'new-design-cell'
};

const SRRICol = {
  header: [() => SRRIColumn.header || null],
  body: [({item, options}) => SRRIColumn.body.content(item, options) || null],
  align: 'right'
};

const SRRIColNew = {
  header: [() => SRRIColumn.header || null],
  body: [({item, options}) => {
    if (options.loading) {
      return <Skeleton />
    }

    const classes = useCellStyles();

    const isSummary = _.get(item, 'tableProps.summaryLine', false);
    const sourceSriConfirmationRequired = options.riskOnSummary && (item.risk_score_confirmation_required || item.experience_confirmation_required);
    const displayTextFieldButton = (isSummary ? sourceSriConfirmationRequired : !options.riskOnSummary) && !options.isOpenOnly && options.clientSRRI && item.sri && item.sri > options.clientSRRI;

    const { onSelectAsset } = useRiskScoreConfirmationModalContext();

    return (
      <>
        {SRRIColumn.body.content(item, options)}

        {displayTextFieldButton && (
          <span className={classes.actionLink} style={{margin: 0, position: 'relative'}}>
            <BcaIconButton
              tooltip={"Begründung"}
              icon={<i className={"fal fa-comment-alt-exclamation"}/>}
              onClick={() => onSelectAsset && onSelectAsset(item)}
              customClasses={{root: classes.reasonBtn}}
            />
          </span>
        )}
      </>
    )
  }],
  cellClassName: 'new-design-cell'
};

const PriceCol = {
  header: [({item, options}) => PriceColumn.header.content(item, options) || null],
  body: [({item, options}) => PriceColumn.body.content(item, options) || null],
  align: 'right'
};

export const PriceColNew = {
  header: [() => "Kurs"],
  body: [({item, options}) => {
    if (options.loading) {
      return <Skeleton />
    }
    if(_.get(item, 'tableProps.summaryLine')){
      return '-'
    }
    return (
      withEuroOrDash(item.calculated && item.calculated.last_price_value)
    )
  }],
  align: 'right',
  cellClassName: 'new-design-cell'
};

const WeightColumn = {
  header: [() => <span>Gewichtung<br/>Einmalanlage</span>],
  body: [({item, options}) => {
    const classes = useCellStyles();

    const weightError = item.error && item.error.weight || '';

    // in case value has more then 2 digits - input will rescale and run onChange with infinite loop (amount <-> weight)
    // to prevent this convert value to 2 digits
    let value = +item.weight;
    value = _.isNaN(value) ? undefined : +value.toFixed(2);

    return (
      <>
        <InputFormElement
          value={value}
          onChange={value => options.handleWeightChange && options.handleWeightChange(item, value)}
          inputComponent={PercentageNumberFormat}
          inputProps={{inputProps: {allowNegative: false, fixedDecimalScale: true}}}
          type={'text'}
          custom_classes={classes}
          disabled={true}
        />
        <Tooltip open={Boolean(weightError)} title={weightError} arrow={true}>
          <div className={classes.tooltip}/>
        </Tooltip>
      </>
    )
  }],
  align: 'right'
};

const WeightColumnNew = {
  header: [() => <span>Gewichtung<br/>Einmalanlage</span>],
  body: [({item}) => withPercentOrDash(item.weight, false)],
  footer: [() => <b>Gesamt</b>],
  align: 'right',
  cellClassName: 'new-design-cell',
  footerCellClassName: 'new-design-footer-cell'
};

const ActionsColumn = {
  header: [() => ''],
  body: [({item, options}) => {
    if(options.readOnly && !options.clientSRRI){
      return null;
    }

    const classes = useCellStyles();

    const displayTextFieldButton = !options.isOpenOnly && options.clientSRRI && item.sri && item.sri > options.clientSRRI

    const { onSelectAsset } = useRiskScoreConfirmationModalContext()

    return (
      <>
        {displayTextFieldButton && (
          <span className={classes.actionLink} style={{margin: 0}}>
            <Link style={!!_.get(item, 'error.risk_score_explanation') ? {color: "red"} : {}} title="Begründung" fontWeight="normal"
                  onClick={() => onSelectAsset && onSelectAsset(item)}/>
          </span>
        )}
        {!options.readOnly && !options.isOpenOnly && (
          <span className={classes.actionLink} style={{margin: 0}}>
            <Link title="Löschen" fontWeight="normal"
                  onClick={() => options.onRemoveAssetClick && options.onRemoveAssetClick(item)}/>
          </span>
        )}
      </>
    )
  }],
  footer: [() => {
    return <>
      <b style={{color: 'black'}}>Verteilt</b><br/>
      <b style={{color: 'black'}}>Saldo</b>
    </>
  }]
};

const ActionsColumnNew = {
  header: [() => ''],
  body: [({item, options}) => {
    return (
      <>
        {(!options.readOnly || _.get(item, 'tableProps.summaryLine')) && !options.isOpenOnly && (
          <BcaDeleteIconButton
            color={'secondary'}
            onClick={() => options.onRemoveAssetClick && options.onRemoveAssetClick(item)}
          />
        )}
      </>
    )
  }],
  footer: [() => ''],
  cellClassName: 'new-design-cell',
  footerCellClassName: 'new-design-footer-cell'
};

const AmountColumn = {
  header: [() => (
    <>
      <span>Einmalanlage</span><br />
      <span>Betrag</span>
    </>
  )],
  body: [({item, options}) => {
    const classes = useCellStyles();

    const error = item.error && item.error.amount || '';

    // in case value has more then 2 digits - input will rescale and run onChange with infinite loop (amount <-> weight)
    // to prevent this convert value to 2 digits
    let value = +item.amount;
    value = _.isNaN(value) ? undefined : +value.toFixed(2);

    const isMP = _.get(item, 'tableProps.summaryLine');
    const singlePaymentImpossible = !isMP && !instrCustodianData(item, options.bankCompanyId).c_single_payment_possible;
    const inputProps = {inputProps: {allowNegative: false, fixedDecimalScale: true}};

    if(singlePaymentImpossible) {
      inputProps.startAdornment = (
        <Tooltip arrow placement={"top"} title={"Einmalanlage nicht verfügbar"}>
          <i className='far fa-info-circle' />
        </Tooltip>
      )
    }

    const readOnly = options.readOnly && !isMP;

    if(options.isNewDesign && readOnly){
      return <div style={{paddingTop: 5}}>{withEuroOrDash(value)}</div>
    }

    return (
      <>
        <InputFormElement
          disabled={readOnly || singlePaymentImpossible || options.isOpenOnly}
          value={value}
          onChange={value => options.handleAmountChange && options.handleAmountChange(item, value)}
          inputComponent={CurrencyNumberFormat}
          inputProps={inputProps}
          type={'text'}
          custom_classes={classes}
        />
        <Tooltip open={Boolean(error)} title={error} arrow={true}>
          <div className={classes.tooltip}/>
        </Tooltip>
        {options.isNewDesign && !!value && (
          <SingleBuyBookingDate
            item={item}
            onChange={options.handleBookingDateChange}
            hasMultipleOrders={options.hasMultipleOrders}
          />
        )}
      </>
    )
  }],
  footer: [({options}) => {
    const {singleBuyAmount, acceptedAmount} = options;

    return <div style={{color: acceptedAmount === singleBuyAmount ? '#23D374' : 'red', paddingRight: 6, whiteSpace: 'nowrap'}}>
      {withEuroOrDash(acceptedAmount)}<br/>
      {withEuroOrDash(acceptedAmount - singleBuyAmount)}
    </div>
  }],
  key: 'AmountColumn',
  align: 'right'
};

const AmountColumnNew = {
  header: [() => (
    <>
      <span>Betrag</span><br />
      <span>Einmalanlage</span>
    </>
  )],
  body: AmountColumn.body,
  footer: [({options}) => {
    const {acceptedAmount} = options;

    return <b style={{paddingRight: 6, whiteSpace: 'nowrap'}}>{withEuroOrDash(acceptedAmount)}</b>
  }],
  cellClassName: 'new-design-cell',
  footerCellClassName: 'new-design-footer-cell',
  key: 'AmountColumn',
  align: 'right'
};

export const OrderAmountColumn = {
  header: [() => 'Betrag'],
  body: [({item}) => <div style={{paddingRight: 6, whiteSpace: 'nowrap'}}>{withEuroOrDash(item.transaction_value)}</div>],
  footer: [({options}) => {
    const {acceptedAmount} = options;

    return <b style={{paddingRight: 6, whiteSpace: 'nowrap'}}>{withEuroOrDash(acceptedAmount)}</b>
  }],
  cellClassName: 'new-design-cell',
  footerCellClassName: 'new-design-footer-cell',
  key: 'OrderAmountColumn',
  align: 'right'
};

export const NumberOfSharesColumnNew = {
  header: NumberOfSharesColumn.header,
  body: NumberOfSharesColumn.body,
  footer: [() => <b>Gesamt</b>],
  cellClassName: 'new-design-cell',
  footerCellClassName: 'new-design-footer-cell',
  key: 'NumberOfSharesColumnNew',
  align: 'right'
};

export const LimitOrderColumnNew = {
  header: [() => 'Limit'],
  body: LimitOrderColumn.body,
  cellClassName: 'new-design-cell',
  key: 'LimitOrderColumnNew',
  align: 'right'
};

export const ShareSettingsColumn = {
  header: [() => <>Orderzusatz<br/>Gültigkeit<br/>Börsenplatz</>],
  body: [({item, options}) => (
    <SharesSettings
      item={item}
      orderTypeOptions={options.orderTypeOptions}
      validityDateOptions={options.validityDateOptions}
      stockExchangeOptions={options.stockExchangeOptions}
      onChange={options.onChange}
      hasMultipleShares={options.hasMultipleShares}
    />
  )],
  cellClassName: 'new-design-cell',
  key: 'ShareSettingsColumn',
};

const SavingsPlanColumn = {
  header: [() => <span>Sparplan<br/>Betrag</span>],
  body: [({item, options}) => {
    if (options.loading) {
      return <Skeleton />
    }
    const classes = useCellStyles();

    const error = item.error && item.error.savingsPlanAmount || '';

    // in case value has more then 2 digits - input will rescale and run onChange with infinite loop (amount <-> weight)
    // to prevent this convert value to 2 digits
    let value = +item.savingsPlanAmount;
    value = _.isNaN(value) ? undefined : +value.toFixed(2);

    const savingsPlanImpossible = !instrCustodianData(item, options.bankCompanyId).c_savings_plan_possible;

    const inputProps = {inputProps: {allowNegative: false, fixedDecimalScale: true}};

    if(savingsPlanImpossible) {
      inputProps.startAdornment = (
        <Tooltip arrow placement={"top"} title={"Sparplan nicht verfügbar"}>
          <i className='far fa-info-circle' />
        </Tooltip>
      )
    }

    return (
      <>
        <InputFormElement
          value={value}
          disabled={options.readOnly || savingsPlanImpossible}
          onChange={value => options.handleSavingsPlanChange && options.handleSavingsPlanChange(item, value)}
          inputComponent={CurrencyNumberFormat}
          inputProps={inputProps}
          type={'text'}
          custom_classes={classes}
        />
        <Tooltip open={Boolean(error)} title={error} arrow={true}>
          <div className={classes.tooltip}/>
        </Tooltip>
      </>
    )
  }],
  footer: [({options}) => {
    const {savingsPlanAmount, savingsPlan} = options;

    return <div style={{color: savingsPlanAmount === savingsPlan ? '#23D374' : 'red', paddingRight: 6, whiteSpace: 'nowrap'}}>
      {withEuroOrDash(savingsPlanAmount)}<br/>
      {withEuroOrDash(savingsPlanAmount - savingsPlan)}
    </div>
  }],
  key: 'SavingsPlanColumn',
  align: 'right'
};

const SavingsPlanColumnNew = {
  header: [() => <span>Betrag<br/>Sparplan</span>],
  body: [({item, options}) => {
    if (options.loading) {
      return <Skeleton />
    }
    const classes = useCellStyles();

    const error = item.error && item.error.savingsPlanAmount || '';

    // in case value has more then 2 digits - input will rescale and run onChange with infinite loop (amount <-> weight)
    // to prevent this convert value to 2 digits
    let value = +item.savingsPlanAmount;
    value = _.isNaN(value) ? undefined : +value.toFixed(2);
    const isMP = _.get(item, 'tableProps.summaryLine');
    const savingsPlanImpossible = !isMP && !instrCustodianData(item, options.bankCompanyId).c_savings_plan_possible;

    const inputProps = {inputProps: {allowNegative: false, fixedDecimalScale: true}};

    if(savingsPlanImpossible) {
      inputProps.startAdornment = (
        <Tooltip arrow placement={"top"} title={"Sparplan nicht verfügbar"}>
          <i className='far fa-info-circle' />
        </Tooltip>
      )
    }

    if(options.readOnly && !isMP){
      return <div style={{paddingTop: 5}}>{withEuroOrDash(value)}</div>
    }

    return (
      <>
        <InputFormElement
          value={value}
          disabled={savingsPlanImpossible || options.isOpenOnly}
          onChange={value => options.handleSavingsPlanChange && options.handleSavingsPlanChange(item, value)}
          inputComponent={CurrencyNumberFormat}
          inputProps={inputProps}
          type={'text'}
          custom_classes={classes}
        />
        <Tooltip open={Boolean(error)} title={error} arrow={true}>
          <div className={classes.tooltip}/>
        </Tooltip>
        {!!value && (
          <SavingPlanSettings
            item={item}
            banksData={options.banksData}
            bankCompanyId={options.bankCompanyId}
            onChange={options.handleSavingsPlanSettingChange}
            hasMultipleSavingsPlans={options.hasMultipleSavingsPlans}
          />
        )}
      </>
    )
  }],
  footer: [({options}) => {
    const {savingsPlanAmount} = options;

    return <b style={{paddingRight: 6, whiteSpace: 'nowrap'}}>{withEuroOrDash(savingsPlanAmount)}</b>
  }],
  key: 'SavingsPlanColumn',
  cellClassName: 'new-design-cell',
  align: 'right',
  footerCellClassName: 'new-design-footer-cell'
};

const SustainabilityCol = {
  header: [SustainabilityCell.header.content],
  body: [({item, options}) => SustainabilityCell.body.content(item, options)]
};

const SustainabilityColNew = {
  header: [(item) => SustainabilityCell.header.content(item, {sustainabilityTitle: 'Nachhal-tigkeit'})],
  body: [({item, options}) => {
    if(_.get(item, 'tableProps.summaryLine')){
      return '-'
    }
    return SustainabilityCell.body.content(item, options)
  }],
  cellClassName: 'new-design-cell'
};

export const tableStructureWithSavingsPlan = [
  StateCol,
  NameCol,
  SustainabilityCol,
  SRRICol,
  PriceCol,
  WeightColumn,
  AmountColumn,
  SavingsPlanColumn,
  ActionsColumn
];

export const newDesignTableStructureWithSavingsPlan = [
  StateCol,
  NameColNew,
  SustainabilityColNew,
  SRRIColNew,
  PriceColNew,
  WeightColumnNew,
  AmountColumnNew,
  SavingsPlanColumnNew,
  ActionsColumnNew
];

export const newDesignTableStructureVL = [
  StateCol,
  {...NameColNew, colSpan: {footer: 4}},
  SustainabilityColNew,
  SRRIColNew,
  {...PriceColNew, footer: WeightColumnNew.footer, footerCellClassName: WeightColumnNew.footerCellClassName},
  SavingsPlanColumnNew,
  ActionsColumnNew
];

export const newDesignTableStructureMP = [
  {...StateCol, cellClassName: 'new-design-cell'},
  {...NameColNew, header: [() => <>Produktname<br/>MP Nummer / ISIN / WKN</>]},
  SustainabilityColNew,
  {...SRRIColNew, header: [() => <>RK/<br/>SRI</>]},
  PriceColNew,
  WeightColumnNew,
  AmountColumnNew,
  SavingsPlanColumnNew,
  ActionsColumnNew
];

export const newDesignTableStructureWithEinzeltitel = [
  StateCol,
  {...NameColNew, colSpan: {footer: 6}},
  SRRIColNew,
  PriceColNew,
  ShareSettingsColumn,
  LimitOrderColumnNew,
  NumberOfSharesColumnNew,
  OrderAmountColumn,
  ActionsColumnNew
];
